import React, { useState, useEffect } from "react";
import { fetchRole } from "../../Redux/Slice/Dropdowns/FetchRoleSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  emailValidation,
  getPhoneNumberLimits,
  handlePhoneNoChange,
  nameValidation,
  phoneNumberValidation,
} from "../../Common/Validations";
import { userSignUp } from "../../Redux/Slice/Authentication/SignUpSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { getUserById } from "../../Redux/Slice/Users/GetUserById";
import { updateUser } from "../../Redux/Slice/Users/UpdateUserSlice";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { Loader } from "../../Common/Loader";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import { resendInvitation } from "../../Redux/Slice/Authentication/ResendInvitationSlice";
import { revokeCustomerMFA } from "../../Redux/Slice/Customers/RevokeCustomerMFASlice";
import { ALL_CALLING_CODES } from "../../Common/Constants";
import { maskNoByCallingCode } from "../../Common/utils";
import CountryPhoneInput from "../../Common/CountryPhoneInput";

export const AddUser = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    roleId: "",
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    countryCallingCode: "+61",
  });
  const [formError, setFormError] = useState({
    emailError: "",
    phoneError: "",
    firstNameError: "",
    lastNameError: "",
  });
  const [isEditForm, setEditForm] = useState(false);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [confirmModel, setCOnfirmModel] = useState("");
  const [hasChangedModel, setHasChangedModel] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [customerId, setCustomerId] = useState("");
  const isEditUser = location.pathname.includes("edit-user");
  const userId = isEditUser ? location.pathname.split("/")[2] : "";
  const [userDetails, setUserDetails] = useState(null);
  const isFromCustomerUserListing = location.state?.isFromCustomerUserListing;
  const parentCustomerId = location.state?.parentCustomerId;
  const userData = JSON.parse(localStorage.getItem("userData"));

  const userRoles = useSelector((state) => state.roles.rolesList);

  const getUserDetails = async () => {
    setIsLoading(true);
    const result = await dispatch(getUserById(userId));
    if (
      getUserById.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setUserDetails(result.payload);
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  useEffect(() => {
    if (userId) {
      getUserDetails();
      setEditForm(true);
    }
  }, [userId]);

  useEffect(() => {
    if (
      (userDetails && userDetails?.data?.parentCustomerId) ||
      isFromCustomerUserListing ||
      userData?.customer?.id
    ) {
      dispatch(fetchRole("customerUser"));
    } else {
      dispatch(fetchRole("user"));
    }
  }, [userDetails, isFromCustomerUserListing]);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));

    if (userData.parentCustomerId) {
      setCustomerId(userData.parentCustomerId);
    } else if (userData?.customer?.id) {
      setCustomerId(userData.parentCustomerId);
    }
    if (userData.customer) {
      setCustomerId(userData.customer.id);
    }
  }, []);

  useEffect(() => {
    if (isEditForm && userDetails) {
      const newPhoneNumber = userDetails.data.phoneNumber.includes(
        userDetails.data.countryCallingCode
      )
        ? userDetails.data.phoneNumber.substring(
            userDetails.data.countryCallingCode.length
          )
        : userDetails.data.phoneNumber;
      setFormData({
        roleId: userDetails.data.role.id,
        email: userDetails.data.email,
        firstName: userDetails.data.firstName,
        lastName: userDetails.data.lastName,
        phoneNumber: newPhoneNumber,
        countryCallingCode: userDetails.data.countryCallingCode,
        userId: props.userId,
        parentCustomerId: parentCustomerId ? parentCustomerId : customerId,
      });
    }
  }, [userDetails]);

  useEffect(() => {
    if (userRoles) {
      setRoles(userRoles?.data);
    }
  }, [userRoles]);

  const handleChange = async (e) => {
    let { name, value } = e.target;
    value = value.trimStart();
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
    if (name === "email") {
      value = value.trimEnd();
      const isValid = emailValidation(value);
      setFormData({ ...formData, [name]: value.trimStart() });
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, emailError: "" });
      } else {
        setFormError({ ...formError, emailError: "Please enter valid Email" });
      }
    } else if (name === "firstName") {
      const isValid = nameValidation(value);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, firstNameError: "" });
      } else {
        setFormError({
          ...formError,
          firstNameError: "Please enter valid name",
        });
      }
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      setFormData({ ...formData, [name]: value });
    } else if (name === "lastName") {
      const isValid = nameValidation(value);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, lastNameError: "" });
      } else {
        setFormError({
          ...formError,
          lastNameError: "Please enter valid name",
        });
      }
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      setFormData({ ...formData, [name]: value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleCountryCodeChange = async (e) => {
    const { name, value } = e.target;
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
    let formatted = formData.phoneNumber;
    setFormData({ ...formData, [name]: value, phoneNumber: formatted });
    const minDigits = getPhoneNumberLimits(value)?.min ?? 10;
    const rawDigits = formData.phoneNumber.replace(/\D/g, "");
    const isValid = phoneNumberValidation(rawDigits, value);
    setFormError({
      ...formError,
      phoneError:
        isValid || value === ""
          ? ""
          : rawDigits.length < minDigits
          ? `Phone number must be at least ${minDigits} digits long.`
          : "Please enter a valid phone number",
    });
  };

  const handlePhoneChange = async (e) => {
    let { name, value } = e.target;
    handlePhoneNoChange(
      e,
      formData.countryCallingCode,
      () => setFormData({ ...formData, [name]: value }),
      (newError) => setFormError({ ...formError, phoneError: newError }),
      (isChanged) => {
        setHasChanged(isChanged);
        dispatch(setUnsavedChanges(true));
      },
      false
    );
  };

  const handleCancel = () => {
    dispatch(setUnsavedChanges(false));
    setCOnfirmModel(false);
    navigate(-1);
    setFormData({
      roleId: "",
      email: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      countryCallingCode: "+61",
    });
  };

  const onClickCancel = () => {
    if (hasChanged) {
      setHasChangedModel(true);
    } else {
      handleCancel();
    }
  };

  const handleUpdate = async () => {
    setCOnfirmModel(false);
    setIsLoading(true);
    const userData = JSON.parse(localStorage.getItem("userData"));
    const customerId2 = userData.parentCustomer
      ? userData.parentCustomer.id
      : userData?.customer?.id
      ? userData.customer.id
      : "";
    let formData2 = new FormData();
    const data = {
      ...formData,
      parentCustomerId: parentCustomerId ? parentCustomerId : customerId2,
      phoneNumber: formData.phoneNumber.replace(/\D/g, ""),
    };
    formData2.append("body", JSON.stringify({ ...data }));
    dispatch(setUnsavedChanges(false));
    const result = await dispatch(
      updateUser({ id: data?.userId, formData: formData2 })
    );
    if (
      updateUser.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessMessage("User Updated Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        navigate(-1);
      }, 1500);
    } else {
      //TODO: error popup here
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };
  const handleSubmit = async () => {
    if (!isEditForm) {
      setIsLoading(true);
      const userData = JSON.parse(localStorage.getItem("userData"));
      const customerId2 = userData.parentCustomer
        ? userData.parentCustomer.id
        : userData?.customer?.id
        ? userData.customer.id
        : "";
      let data = {
        ...formData,
        parentCustomerId: parentCustomerId ? parentCustomerId : customerId2,
        createdByCustomer: (parentCustomerId ? parentCustomerId : customerId2)
          ? true
          : false,
        phoneNumber: formData.phoneNumber.replace(/\D/g, ""),
      };
      if (data.parentCustomerId) {
        data = {
          ...data,
          isActive: true,
          isMfaEnabled: false,
        };
      }
      dispatch(setUnsavedChanges(false));
      const result = await dispatch(userSignUp(data));
      if (
        userSignUp.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        setIsLoading(false);
        setSuccessMessage("User Created Successfully!");
        setSuccessModel(true);
        setTimeout(() => {
          setSuccessModel(false);
          navigate(-1);
        }, 1500);
      } else {
        //TODO: error popup here
        setIsLoading(false);
        setErrorMessage(result?.payload?.error?.message);
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    } else {
      setCOnfirmModel(true);
    }
  };

  const revokeMFA = async () => {
    setIsLoading(true);
    try {
      const result = await dispatch(revokeCustomerMFA(formData?.userId));
      if (
        revokeCustomerMFA.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        setIsLoading(false);
        dispatch(setUnsavedChanges(false));
        setSuccessMessage("MFA Revoked Successfully!");
        setSuccessModel(true);
        setTimeout(() => {
          setSuccessModel(false);
        }, 1500);
      } else {
        setIsLoading(false);
        setErrorMessage(result?.payload?.error?.message);
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    } catch (error) {
      setIsLoading(false);
      setErrorMessage("Something went wrong, Please try again later.");
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendInvitation = async () => {
    const result = await dispatch(resendInvitation({ email: formData.email }));
    if (
      resendInvitation.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessMessage("User Invite Resend Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        navigate(-1);
      }, 1500);
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  return (
    <div className="page__body">
      {isLoading ? <Loader /> : ""}
      <div className="details">
        <div className="form">
          <section className="form__section">
            <h1 className="form__section__title">User Details</h1>
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field">
                  <label htmlFor="firstname" className="form__label">
                    First Name <span style={{ color: "red" }}> * </span>
                  </label>
                  <input
                    type="text"
                    id="firstname"
                    maxLength={30}
                    onChange={handleChange}
                    name="firstName"
                    value={formData.firstName}
                    className="form__input form__input--sm"
                    placeholder="First Name"
                  />
                </div>
                <div className="form__error">{formError.firstNameError}</div>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label htmlFor="lastname" className="form__label">
                    Last Name <span style={{ color: "red" }}> * </span>
                  </label>
                  <input
                    type="text"
                    id="lastname"
                    maxLength={30}
                    onChange={handleChange}
                    name="lastName"
                    value={formData.lastName}
                    className="form__input form__input--sm"
                    placeholder="Last Name"
                  />
                </div>
                <div className="form__error">{formError.lastNameError}</div>
              </div>
            </div>
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field">
                  <label htmlFor="email" className="form__label">
                    Email <span style={{ color: "red" }}> * </span>
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    maxLength={100}
                    disabled={isEditForm}
                    value={formData.email}
                    onChange={handleChange}
                    className={
                      isEditForm
                        ? "form__input form__input--sm form__input--disabled"
                        : "form__input form__input--sm"
                    }
                    placeholder="Email"
                  />
                </div>
                <div className="form__error"> {formError.emailError}</div>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label htmlFor="role" className="form__label">
                    Role <span style={{ color: "red" }}> * </span>
                  </label>
                  <select
                    id="role"
                    name="roleId"
                    value={formData.roleId}
                    onChange={handleChange}
                    className="form__select form__select--sm"
                  >
                    <option value="" selected disabled>
                      -Select-
                    </option>
                    {roles
                      ? roles.map((role) => {
                          return (
                            <option value={role.id} selected="">
                              {role.label}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
              </div>
              {/* <div className="formCol">
                <div className="form__Field">
                  <label htmlFor="position" className="form__label">
                    Position
                  </label>
                  <input
                    type="email"
                    id="position"

                    className="form__input form__input--sm"
                    placeholder="Position"
                  />
                </div>
              </div> */}
              <div className="formCol">
                <div className="form__Field">
                  <label htmlFor="phonenumber" className="form__label">
                    Phone Number
                  </label>
                    <CountryPhoneInput
                      countryCodeFieldName="countryCallingCode"
                      phoneFieldName="phoneNumber"
                      countryCode={formData.countryCallingCode}
                      phoneNumber={formData.phoneNumber}
                      onCountryChange={handleCountryCodeChange}
                      onPhoneChange={handlePhoneChange}
                    />
                  <div className="form__error">{formError.phoneError}</div>
                </div>
              </div>
            </div>
            <div className="btn__group">
              <button
                className="btn btn__white"
                type="button"
                onClick={onClickCancel}
              >
                Cancel
              </button>
              <button
                className="btn btn__primary"
                type="submit"
                disabled={
                  hasChanged === false ||
                  formData.firstName.trim() === "" ||
                  formData.lastName.trim() === "" ||
                  formError.emailError != "" ||
                  formError.firstNameError != "" ||
                  formError.lastNameError != "" ||
                  formError.phoneError != "" ||
                  formData.roleId === "" ||
                  formData.email.trim() === ""
                }
                onClick={handleSubmit}
              >
                {isEditForm ? "Update" : "Save"}
              </button>
              {isEditForm && userDetails && isFromCustomerUserListing ? (
                <button
                  className="btn btn__primary"
                  type="submit"
                  onClick={() => {
                    revokeMFA();
                  }}
                >
                  Revoke MFA
                </button>
              ) : null}
              {userId && userDetails?.data?.isInvited ? (
                <button
                  className="btn btn__primary"
                  type="submit"
                  onClick={handleResendInvitation}
                >
                  Resend Invitation
                </button>
              ) : null}
            </div>
          </section>
        </div>
      </div>
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {confirmModel ? (
        <ConfirmModel
          onAccept={handleUpdate}
          yes={"Update"}
          no={"Cancel"}
          onReject={() => {
            setCOnfirmModel(false);
          }}
          title="Update Changes!"
          message="Are you sure you want to update the changes?"
        />
      ) : (
        ""
      )}
      {hasChangedModel ? (
        <ConfirmModel
          onAccept={handleCancel}
          yes={"Yes"}
          no={"No"}
          onReject={() => {
            setHasChangedModel(false);
          }}
          title="Update Changes!"
          message="Changes made will not be saved. Are you sure you want to leave the page?"
        />
      ) : null}
    </div>
  );
};
